import React from "react";
import VideoMerge from "./components/VideoMerge/VideoMerge";
import Techies from "./components/Techies/Techies";
import JsonToTypeScript from "./components/JsonToTypeScript/JsonToTypeScript";
import PlateBlurTool from "./components/PlateBlurTool/PlateBlurTool";
import "./App.css";
import Editorial, {
  Header,
  Footer,
  Toolkit,
} from "./components/Editorial/Editorial";
import { HashRouter, Route, Routes } from "react-router-dom";
import AddArticle from "./components/AddArticle/AddArticle";
import Contact from "./components/Contact/Contact";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import Dashboard from "./components/Dashboard/Dashboard";
import Article from "./components/Article/Article";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions/TermsConditions";
import Tag from "./components/Tag/Tag";
import KeywordExtractionTool from "./components/KeywordExtractionTool/KeywordExtractionTool";
import UUIDGenerator from "./components/UUIDGenerator/UUIDGenerator";
import SurveyBuilderTool from "./components/SurveyBuilderTool/SurveyBuilderTool";
import JwtTokenGenerator from "./components/JwtTokenGenerator/JwtTokenGenerator";
import JsonFormatter from "./components/JsonFormatter/JsonFormatter";
import RegexGenerator from "./components/RegexGenerator/RegexGenerator";
import CompareTextAreas from "./components/CompareTextAreas/CompareTextAreas";
import QRCodeGenerator from "./components/QRCodeGenerator/QRCodeGenerator";
import InvoiceGenerator from "./components/InvoiceGenerator/InvoiceGenerator";
import BusinessNameGenerator from "./components/BusinessNameGenerator/BusinessNameGenerator";
import VerifyAccount from "./components/VerifyAccount/VerifyAccount";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import RomanConverter from "./components/RomanConverter/RomanConverter";
import TimeZoneConverter from "./components/TimeZoneConverter/TimeZoneConverter";
import ArticleManager from "./components/ArticleManager/ArticleManager";
import AddBusinessArticle from "./components/AddBusinessArticle/AddBusinessArticle";
import AddHomeAndGardenArticle from "./components/AddHomeAndGardenArticle/AddHomeAndGardenArticle";
import BulkArticlePost from "./components/BulkArticlePost/BulkArticlePost";
import CustomEditor from "./components/CustomEditor/CustomEditor";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Header />
        <main id="main-content" tabIndex={-1}>
          <Routes>
            <Route path="/techies/*" element={<Techies />} />
            <Route path="/home" element={<Editorial />} />
            <Route path="/" element={<Editorial />} />
            <Route path="/addarticle" element={<AddArticle />} />
            <Route
              path="/categories"
              element={<Editorial mode="categories" />}
            />
            <Route path="/article" element={<Article />} />
            <Route path="/article/:slug/:id" element={<Article />} />
            <Route
              path="/survey-builder-tool"
              element={<SurveyBuilderTool />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/popular" element={<Editorial mode="popular" />} />
            <Route path="/latest" element={<Editorial mode="latest" />} />
            <Route path="/tags" element={<Tag />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/smart-tools" element={<Toolkit />} />
            <Route path="/video-merger" element={<VideoMerge />} />
            <Route path="/plate-blur" element={<PlateBlurTool />} />
            <Route path="/json-to-typescript" element={<JsonToTypeScript />} />
            <Route path="/uuid-generator" element={<UUIDGenerator />} />
            <Route path="/json-formatter" element={<JsonFormatter />} />
            <Route
              path="/jwt-token-generator"
              element={<JwtTokenGenerator />}
            />
            <Route path="/regex-generator" element={<RegexGenerator />} />
            <Route path="/compare-text" element={<CompareTextAreas />} />
            <Route path="/qr-code-generator" element={<QRCodeGenerator />} />
            <Route path="/verify-account" element={<VerifyAccount />} />
            <Route path="/invoice-generator" element={<InvoiceGenerator />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/integer-roman" element={<RomanConverter />} />
            <Route path="/article-manager" element={<ArticleManager />} />
            <Route path="/custom-edit" element={<CustomEditor />} />
            <Route
              path="/add-business-article"
              element={<AddBusinessArticle />}
            />
            <Route path="/article-bulk-post" element={<BulkArticlePost />} />
            <Route
              path="/add-hg-article"
              element={<AddHomeAndGardenArticle />}
            />
            <Route
              path="/time-zone-converter"
              element={<TimeZoneConverter />}
            />
            <Route
              path="/business-name-generator"
              element={<BusinessNameGenerator />}
            />
            <Route
              path="/keyword-extraction"
              element={<KeywordExtractionTool />}
            />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
          </Routes>
        </main>
        <Footer />
      </HashRouter>
    </div>
  );
}

export default App;
